import './ParcelMap.scss';
import Component from './ParcelMap.js';
export default Component;
